import React, { useEffect, useState } from "react";
import Helmet from "react-helmet";
import logo from "../assets/images/logo.png";
import { Toaster } from "react-hot-toast";
import Routers from "../routes";
import { getLocalStorage } from "../utils/function/localStorage";
import errorIcon from "../assets/images/error.png";
import successIcon from "../assets/images/checkmark.png";
//import Randommodal from "../screens/Dashboard/Randommodal";
import { HeaderProvider } from "../context/HeaderContext";
import Header from "../components/Dashboard/Header";

const App = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const token = getLocalStorage("tp_Aa_uth_access");
    const hasRefreshed = localStorage.getItem("app_refreshed");

    if (token && !hasRefreshed) {
      localStorage.setItem("app_refreshed", "true");
      window.location.reload();
    }
  }, []);
useEffect(() => {
  const lastShownTime = localStorage.getItem("random_modal_last_shown");
  const now = Date.now();
  const ONE_HOUR = 1 * 60 * 60 * 1000;
  const shouldShowModal = !lastShownTime || (now - parseInt(lastShownTime, 10)) > ONE_HOUR;
  if (shouldShowModal) {
    const timer = setTimeout(() => {
      setShowModal(true);
      localStorage.setItem("random_modal_last_shown", Date.now().toString());
    }, 2 * 60 * 1000); // wait 2 minutes
    return () => clearTimeout(timer);
  }
}, []);

  return (
    <HeaderProvider>
      <Helmet>
        <title>Taskplanet</title>
        <link rel="shortcut icon" href={logo} type="image/x-icon" />
        <link rel="apple-touch-icon" href={logo} />
      </Helmet>
      <Toaster
        position="top-center"
        reverseOrder={true}
        toastOptions={{
          error: {
            icon: <img style={{ width: 24, height: 24 }} src={errorIcon} alt="error" />,
            style: {
              background: "#F8100E",
              color: "#fff",
              fontWeight: "700 !important",
            },
          },
          success: {
            icon: <img style={{ width: 24, height: 24 }} src={successIcon} alt="success" />,
            style: {
              background: "#1ABF3D",
              color: "#fff",
              fontWeight: "700 !important",
            },
          },
        }}
      />
       <Header />
      <Routers />
      {/* {showModal && <Randommodal/>} */}
    </HeaderProvider>
  );
};

export default App;
